import { createStore } from "zustand/vanilla";

export type TChat = {
  aka: string;
  st?: {
    id: number;
    m: boolean;
    t: string;
    l: string;
  }[];
  lc: string;
  cc: string;
  ncmt: number;
  mi_ml: number;
  ma_ml: number;
  t?: number;
  a_id?: number;
  al?: string;
  rp?: boolean;
};

export type TDict = {
  [key: string]: string;
};

export type TNotificationRepo = {
  isInitConnect: boolean;
  chat: null | TChat;
  dict: null | TDict;
  time: number;
  initConnect: () => void;
  connect: () => void;
  disconnect: () => void;
  getTime: () => number;
};

export const notificationRepo = createStore<TNotificationRepo>((set, get) => {
  return {
    isInitConnect: false,
    chat: null,
    dict: null,
    time: Date.now(),
    connect: () => {
      set({ isInitConnect: false });
    },
    initConnect: () => {
      set({ isInitConnect: true });
    },
    disconnect: () => {
      // no-op: websocket notifications removed
    },
    getTime: () => get().time,
  };
});

export default notificationRepo;
